// 第1张
const imgAllA = {
    us: {
        pc: '',
        h5: '',
    },
    AU: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1736750479923/BMS-2.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1736905844676/Space-saving%20design.jpg',
    },
};
const imgLocale: any = {
    au: imgAllA.AU,
};
export default imgLocale;
